import React, { ReactElement } from 'react';

const WarningTriangleIcon = (): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-cy="warning-triangle-icon"
    style={{ width: '100%', height: '100%' }}
  >
    <path d="M12 2L1 21h22L12 2z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="17" r="0.8" fill="currentColor" />
  </svg>
);

export default WarningTriangleIcon;
